module.exports = __webpack_public_path__ + "img/tab_unselected.2c25577b.svg";